import ServiceCategoryPage from "../components/ServiceCategoryPage";
import nannyCaretakerService from "../data/services/nannyCaretakerService";

function NannyCaretaker() {
  return <ServiceCategoryPage service={nannyCaretakerService} />;
}

export default NannyCaretaker;